/* prettier-ignore */

import { computed, Injectable, signal } from '@angular/core';
import { environment } from 'src/environments/environment';

@Injectable({ providedIn: 'root' })

export class DebugService {
    private shouldLog = signal<boolean>(!environment.production);

    enableLogs(){
        this.shouldLog.set(true);
    }

    private formatLog(level: string, log: any, key?: string) {
        const colors = {
            INFO: 'color: #7fc1fa; font-weight: bold;',
            DEBUG: 'color: #f39ffc; font-weight: bold;',
            WARN: 'color: #fac57f; font-weight: bold;',
            ERROR: 'color: #fa6b6b; font-weight: bold;'
        };

        const style = colors[level] || '';
        if (key) console.log(`%c[${level}] ${key}:`, style, log);
        else console.log(`%c[${level}]`, style, log);
    }

    debug(log: any, key?: string) {
        if (this.shouldLog()) this.formatLog('DEBUG', log, key);
    }

    info(log: any, key?: string) {
        if (this.shouldLog()) this.formatLog('INFO', log, key);
    }

    warn(log: any, key?: string) {
        if (this.shouldLog()) this.formatLog('WARN', log, key);
    }

    error(log: any, key?: string) {
        this.formatLog('ERROR', log, key);
    }
}